import Header from "./common/Header.js";
import Footer from "./common/Footer.js";
import useWindowSize from "react-use/lib/useWindowSize";
import Confetti from "react-confetti";

export default function SignupWizardEnrollmentConfirmation(props) {
  if (props.state.wizardStep !== "enrollment_confirmation") {
    return null;
  } else {
    window.onbeforeunload = null;
  }
  return (
    <div className="App confirmationBG">
      <Header />
      <Confirmation currentState={props.state} continueToPayment={props.continueToPayment} />
      <Footer confirmation={true} />
    </div>
  );
}

const Confirmation = (props) => {
  const { width, height } = useWindowSize();
  const recycle = false;
  return (
    <div id="about" className="section wide img light confirmation">
      <Confetti width={width} height={height} recycle={recycle} style={{ zIndex: "9999999" }} />
      <div className="wrap confirmation">
        <h2 className="heading-4 confirm">
          You’re all set{" "}
          {props.currentState.caregiverFlow ? props.currentState.caregiverFirstName : props.currentState.firstName}!
          <br />
        </h2>
        <div className="confirmationcontainer w-container">
          <h2
            className="paragraph-2 confirmation"
            style={{ display: !props.currentState.caregiverFlow ? "block" : "none" }}
          >
            Your free 14-day trial starts soon.
            <br />
          </h2>
          <h2
            className="paragraph-2 confirmation"
            style={{ display: !props.currentState.caregiverFlow ? "none" : "block" }}
          >
            Your free 14-day trial starts soon.
            <br />
          </h2>
          <h2 className="paragraph-2 orange">
            What comes next?
            <br />
          </h2>
          <h2
            className="paragraph-2 confirmation"
            style={{ display: props.currentState.caregiverFlow ? "block" : "none" }}
          >
            A Duos team member will give you a call shortly for a no-pressure chat about your loved ones needs, our service,
            and enrollment.
            <br />
          </h2>
          <h2
            className="paragraph-2 confirmation"
            style={{ display: props.currentState.caregiverFlow ? "none" : "block" }}
          >
            A Duos team member will give you a call shortly for a no-pressure chat about your needs, our service, and
            enrollment.
            <br />
          </h2>
        </div>
        <a href="https://www.getduos.com/welcome" className="button-hero sub w-button">
          Back to DUOS
        </a>
        <a
          href="#/"
          role="button"
          onClick={(ev) => {
            ev.preventDefault();
            props.continueToPayment();
          }}
        >
          Continue to payment
        </a>
      </div>
    </div>
  );
};
